"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "@/components/link";
import UserIcon from "@/components/UserIcon";
import { useBlockableRouter } from "@/components/navigation-block";
import { Button } from "@/components/ui/button";
import { useLogout, useUserSummary } from "@/lib/api/user";
import { ThemeSwitcher } from "./ui/theme-switcher";
import { LanguageSwitcher } from "./language-switcher";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Building2, CalendarDays, Home, Settings, User, UserX } from "lucide-react";
import React from "react";
import { useTranslations } from "next-intl";
interface UserNavProps {
  children: React.ReactNode;
  isMenuOpen?: boolean;
  setIsMenuOpen?: (open: boolean) => void;
  actionsMenu?: React.ReactNode[];
  showUserInfo?: boolean;
  showAvatar?: boolean;
}
export function UserNav(t0) {
  const $ = _c(42);
  const {
    children,
    isMenuOpen,
    setIsMenuOpen,
    actionsMenu,
    showUserInfo: t1,
    showAvatar: t2
  } = t0;
  const showUserInfo = t1 === undefined ? false : t1;
  const showAvatar = t2 === undefined ? false : t2;
  const t = useTranslations();
  const {
    data
  } = useUserSummary();
  const router = useBlockableRouter();
  const user = data?.user;
  let t3;
  if ($[0] !== data?.events) {
    t3 = data?.events ?? [];
    $[0] = data?.events;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const events = t3;
  let t4;
  if ($[2] !== data?.organizations) {
    t4 = data?.organizations ?? [];
    $[2] = data?.organizations;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const organizations = t4;
  let t5;
  if ($[4] !== router) {
    t5 = {
      onSuccess: () => {
        router.push("/login");
      }
    };
    $[4] = router;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const logoutMutation = useLogout(t5);
  let t6;
  if ($[6] !== logoutMutation) {
    t6 = async function handleLogout() {
      await logoutMutation.mutateAsync();
    };
    $[6] = logoutMutation;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleLogout = t6;
  let t7;
  if ($[8] !== children) {
    t7 = <PopoverTrigger asChild={true}>{children}</PopoverTrigger>;
    $[8] = children;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== showUserInfo || $[11] !== t || $[12] !== user) {
    t8 = showUserInfo && <div className="flex flex-col space-y-1 px-2 pb-4 mb-2 border-b"><p className="text-sm font-medium leading-none">{user?.name ?? t("user-nav.unknown-user")}</p>{user?.description && <p className="text-xs leading-none text-muted-foreground">{user.description}</p>}</div>;
    $[10] = showUserInfo;
    $[11] = t;
    $[12] = user;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== actionsMenu) {
    t9 = actionsMenu?.length ? <div className="flex flex-col gap-2 mb-3 pb-3 border-b">{actionsMenu}</div> : null;
    $[14] = actionsMenu;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== events || $[17] !== handleLogout || $[18] !== organizations || $[19] !== t || $[20] !== user) {
    t10 = user && <><Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/"><Home />{t("user-nav.home")}</Link></Button><Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/events"><CalendarDays />{t("user-nav.events")}</Link></Button>{organizations.length > 0 && <Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/organizer"><Building2 />{t("user-nav.organization")}</Link></Button>}<Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/profile/settings/profile"><Settings />{t("user-nav.settings")}</Link></Button><Button variant="link" className="justify-start text-foreground" onClick={handleLogout}><UserX />{t("user-nav.logout")}</Button></> || <>{events.map(_temp)}{events.length > 0 && <hr />}<Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/login"><User />{t("user-nav.login")}</Link></Button><Button variant="link" asChild={true} className="justify-start text-foreground"><Link href="/login/signup"><User />{t("user-nav.register")}</Link></Button></>;
    $[16] = events;
    $[17] = handleLogout;
    $[18] = organizations;
    $[19] = t;
    $[20] = user;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10) {
    t11 = <div className="mb-3 pb-3 border-b flex flex-col gap-2">{t10}</div>;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  let t13;
  let t14;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <ThemeSwitcher />;
    t13 = <LanguageSwitcher />;
    t14 = <div className="flex-1" />;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t12 = $[24];
    t13 = $[25];
    t14 = $[26];
  }
  let t15;
  if ($[27] !== showAvatar || $[28] !== user) {
    t15 = showAvatar && (user ? <UserIcon user={user} size={32} showInfo={true} /> : <span className="text-sm">?</span>);
    $[27] = showAvatar;
    $[28] = user;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <div className="flex items-center">{t12}{t13}{t14}{t15}</div>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t11 || $[33] !== t16 || $[34] !== t8 || $[35] !== t9) {
    t17 = <PopoverContent align="end" className="w-64 lg:w-78 p-3">{t8}{t9}{t11}{t16}</PopoverContent>;
    $[32] = t11;
    $[33] = t16;
    $[34] = t8;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== isMenuOpen || $[38] !== setIsMenuOpen || $[39] !== t17 || $[40] !== t7) {
    t18 = <Popover open={isMenuOpen} onOpenChange={setIsMenuOpen}>{t7}{t17}</Popover>;
    $[37] = isMenuOpen;
    $[38] = setIsMenuOpen;
    $[39] = t17;
    $[40] = t7;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
}
function _temp(event) {
  return <Button key={event.id} variant="link" asChild={true} className="justify-start text-foreground"><Link href={`/event/${event.id}`}><CalendarDays />{event.title}</Link></Button>;
}